<template>
    <!-- <div id="grid grid-cols-4 gap-4">
        <button @click="removeIndex"
                class="flex mx-auto bg-blue-700 hover:bg-blue-900 text-white uppercase tracking-wider text-sm
                    font-semibold px-10 py-3 mb-3 rounded absolute center-0 left-0">
                    Prev
            </button>
        <ul class="col-span-2">
            <li v-for="(banner, index) in photos" :key="index" :class="{ on: index === currentIndex }">
                <img :src="banner.photo_link" :alt="index" class="block object-fill" style="height: 60vh; width: 50%">
            </li>
        </ul>

        
            
             <p class="center-0">{{currentIndex + 1 }} / {{photos.length}}</p>
            <button @click="addIndex"
                    class="flex mx-auto bg-blue-700 hover:bg-blue-900 text-white uppercase tracking-wider text-sm
                font-semibold px-10 py-3 mb-3 rounded">
                Next
            </button>

       
        
    </div> -->
    <div class="bg-gray-100 h-full flex mx-auto flex-col justify-center items-center w-11/12">
  
    <div class="max-w-4xl mx-auto relative">

    <!-- Slides -->

      <div
         class="h-5/6 w-96 flex items-center bg-blue-800 text-white rounded-lg">
        <ul>
            <li v-for="(banner, index) in photos" :key="index" :class="{ on: index === currentIndex }">
                <img :src="banner.photo_link" :alt="index" class="object-fill w-96" style="height: 70vh;">
            </li>
        </ul>
      </div>
 
 <div class="absolute inset-0 flex rounded-full" >
    <span class="ml-2 mt-2 text-sm px-3 py-2 rounded-lg bg-blue-100 text-blue-900 h-10">{{currentIndex + 1 }} / {{photos.length}}</span>
 </div>
    
    
    <!-- Prev/Next Arrows -->
    <div class="absolute inset-0 flex">
      <div class="flex items-center justify-start w-1/2">
        <button 
          class="bg-blue-100 text-blue-800 hover:text-orange-500 font-bold hover:shadow-lg rounded-full w-12 h-12 -ml-6"
          @click="removeIndex">
          &#8592;
         </button>
      </div>
      <div class="flex items-center justify-end w-1/2">
        <button 
          class="bg-blue-100 text-blue-800 hover:text-orange-500 font-bold hover:shadow rounded-full w-12 h-12 -mr-6"
          @click="addIndex">
          &#8594;
        </button>
      </div>        
    </div>

    <!-- Buttons -->
    <!-- <div class="absolute w-full flex items-center justify-center px-4">
      <div v-for="(banner, index) in photos" :key="index">
        <button
          class="flex-1 w-4 h-2 mt-4 mx-2 mb-0 rounded-full overflow-hidden transition-colors duration-200 ease-out hover:bg-teal-600 hover:shadow-lg"
          :class="{ 
              'bg-blue-800': index !== currentIndex,
              'bg-orange-500': index === currentIndex 
          }" 
          @click="setIndex(index)"
        ></button>
      </div>
    </div> -->
  </div>
  
  </div>


</template>

<script>
    // let timer = null;
    // const AUTO_INTERVAL = 2000;
    export default {
        name: "viewer",
        props: {photos: Array},
        data: function(){
            return {
                playing: false,
                currentIndex: 0
            }
        },
        methods: {
            setAutoRoll() {
                // let vueSelf = this;
                // timer = setInterval(function() {
                //     vueSelf.addIndex();
                // }, AUTO_INTERVAL);
            },
            addIndex() {
                let newIndex = this.currentIndex + 1;
                // console.log(newIndex);
                this.currentIndex = newIndex > this.photos?.length - 1 ? 0 : newIndex;
                // console.log(this.currentIndex);
            },

            removeIndex(){
                let newIndex = this.currentIndex - 1;
                // console.log(newIndex);
                this.currentIndex = newIndex < 0 ? this.photos?.length - 1 : newIndex;
                // console.log(this.currentIndex);
            },

            setIndex(index){
                this.currentIndex = index;

            },
            // roll(direction) {
            //     let diff = direction === "prev" ? -1 : 1;
            //     this.currentIndex = this.getTargetIndex(diff);
            //     if(this.playing) {
            //         // clearInterval(timer);
            //         // this.setAutoRoll();
            //     }
            // },
            play() {
                // this.setAutoRoll();
                this.playing = true;
            },

            getTargetIndex(diff) {
                let length = this.photos.length;
                let index = this.currentIndex + diff;
                if (index === -1) {
                    return length - 1;
                }
                if (index === length) {
                    return 0;
                }
                return index;
            }
        },

        created() {
            this.play();
        }

    }
</script>

<style scoped>


    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    li {
        display: none;
    }
    li.on {
        display: block;
    }

</style>
